import React from 'react'
import { Label } from 'core/screen-util'
const DailyEventHoverDetails = ({ data, height = 200 }) => {
  const { eventNum, eventType, causeCode, availCap } = data
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '60% 40%',
        border: '1px solid black',
        gap: '2px',
        padding: '2px',
        height: height + 'px',
      }}
    >
      <Label>Event Num :</Label>
      <div>
        <b>{eventNum}</b>
      </div>
      <Label>Event Type :</Label>
      <div>
        <b>{eventType}</b>
      </div>
      <Label>Cause Code :</Label>
      <div>
        <b>{causeCode}</b>
      </div>
      <Label>Available MW :</Label>
      <div>
        <b>{availCap}</b>
      </div>
    </div>
  )
}

export default DailyEventHoverDetails
